// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Section-module__main--Kfaag {
}

.Section-module__title--QMd0T {
    margin-bottom: 16px;
}

.Section-module__content--ufyXE {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Panel/Section.module.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ","sourcesContent":[".main {\n}\n\n.title {\n    margin-bottom: 16px;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Section-module__main--Kfaag`,
	"title": `Section-module__title--QMd0T`,
	"content": `Section-module__content--ufyXE`
};
export default ___CSS_LOADER_EXPORT___;
